/**
 * Resuelve el monto (guarantee_amount / note_amount) usando como fallback el primer
 * elemento de approved_amount cuando el campo propio es null o 0.
 * Evita el crash con TypeError si approved_amount es un array vacío.
 */
export function resolveAmountFallback(
  fieldValue: number | null | undefined,
  approvedAmount: Array<{ value: number }> | undefined | null
): number | null {
  if (fieldValue === null || fieldValue === 0) {
    return approvedAmount?.[0]?.value ?? null;
  }
  return fieldValue ?? null;
}
